module.exports = __webpack_public_path__ + "static/media/bg_ok.490eb890.svg";